export default "__VITE_ASSET__DZZC6UKf__"